"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Model = /** @class */ (function () {
    // by default babel initialize every property as undefined, which takes place after the super() call
    // to prevent this behaviour the children classes should use declare which requires @babel/plugin-transform-typescript
    //
    // after install the plugin, add it to the babel config:
    // "plugins": [["@babel/plugin-transform-typescript", {"allowDeclareFields": true}]]
    //
    // more info https://github.com/babel/babel/issues/8417
    function Model(data) {
        Object.assign(this, __assign({}, data));
    }
    return Model;
}());
exports.default = Model;
